import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=1a4bc85f&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&lang=ts"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=1a4bc85f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bc85f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4bc85f')) {
      api.createRecord('1a4bc85f', component.options)
    } else {
      api.reload('1a4bc85f', component.options)
    }
    module.hot.accept("./ClientDetails.vue?vue&type=template&id=1a4bc85f&scoped=true", function () {
      api.rerender('1a4bc85f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/components/ClientDetails.vue"
export default component.exports